import Login from "@/views/Auth/Login.vue";
import ForgotPassword from "@/views/Auth/ForgotPassword.vue";
import NewPassword from "@/views/Auth/NewPassword.vue";

const routesAuth = [
    {
        path: 'login',
        name: 'login',
        component: Login
    },
    {
        path: 'forgot-password',
        name: 'forgotPassword',
        component: ForgotPassword,
        meta: {
            public: true
        }
    },
    {
        path: 'new-password',
        name: 'newPassword',
        component: NewPassword,
        meta: {
            public: true
        }
    }
  ]

export default routesAuth